import React from 'react';
import { Swiper as SwiperReact } from 'swiper/react';
import { SwiperModule } from 'swiper/types';

import { ArrowIcon } from '@/shared/ui/icons';

import 'swiper/css';

import {
    StyledSliderContainer,
    StyledSliderPrevNavButton,
    StyledSliderNextNavButton,
    StyledBulletContainer,
    StyledSliderBullets,
} from './styled';

type PaginationProps = {
    el: string;
    bulletClass: string;
    bulletActiveClass: string;
    clickable: boolean;
};

type NavigationProps = {
    nextEl: string;
    prevEl: string;
};

type TProps = {
    children?: React.ReactNode;
    modules?: SwiperModule[];
    prev?: string;
    next?: string;
    draggable?: boolean;
    pagination?: PaginationProps;
    navigation?: NavigationProps;
    slidesPerView?: number | 'auto' | undefined;
    spaceBetween?: number;
    breakpoints?: object;
    containerName?: string;
    bulletsTop?: boolean;
    showBullets?: boolean;
    centeredSlides?: boolean;
};

export const Swiper: React.FC<TProps> = ({
    children,
    slidesPerView,
    modules,
    draggable = false,
    prev = 'prev',
    next = 'next',
    containerName,
    bulletsTop,
    showBullets = false,
    centeredSlides,
    spaceBetween,
}) => {
    return (
        <>
            {bulletsTop && showBullets && <Bullets />}
            <StyledSliderContainer className={containerName}>
                <SwiperReact
                    modules={modules}
                    slidesPerView={slidesPerView}
                    pagination={{
                        el: '.bullets',
                        bulletClass: 'my-bullet',
                        bulletActiveClass: 'bullet-active',
                        clickable: true,
                    }}
                    navigation={{
                        nextEl: `.${next}`,
                        prevEl: `.${prev}`,
                    }}
                    draggable={draggable}
                    centeredSlides={centeredSlides}
                    spaceBetween={spaceBetween}
                >
                    {children}
                </SwiperReact>
                <StyledSliderPrevNavButton className={prev}>
                    <ArrowIcon />
                </StyledSliderPrevNavButton>
                <StyledSliderNextNavButton className={next}>
                    <ArrowIcon />
                </StyledSliderNextNavButton>
            </StyledSliderContainer>
            {!bulletsTop && showBullets && <Bullets />}
        </>
    );
};

const Bullets: React.FC = () => (
    <StyledBulletContainer>
        <StyledSliderBullets className="bullets">
            <div className="my-bullet bullet-active"></div>
            <div className="my-bullet"></div>
            <div className="my-bullet"></div>
            <div className="my-bullet"></div>
        </StyledSliderBullets>
    </StyledBulletContainer>
);
